import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import qs from "qs";
import { ACTIVE_WEB_LOGIN } from "../../api/apiRoutes";
import { Box, Grid } from "@material-ui/core";
import useApiRequest from "../../utils/hook/useApiRequest";
import { Alert } from "@material-ui/lab";
import { useDispatch } from "react-redux";
import { setSuccessMessage } from "../../store/alerts/alertsActions";

const styleDiv = { marginBottom: 100, width: "100%" };

const ActiveAccount: React.FC<RouteComponentProps> = ({ location }) => {
  const activeToken = qs.parse(location.search.slice(1)).access_token as string;
  const { post } = useApiRequest();
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();

  const activeAccount = async () => {
    const { isError } = await post(ACTIVE_WEB_LOGIN, { a: activeToken });
    dispatch(setSuccessMessage("Konto zostało aktywowane"));
    setSuccess(isError);
  };

  useEffect(
    () => {
      activeAccount();
    }, // eslint-disable-next-line
    []
  );

  return (
    <Box style={styleDiv}>
      <Grid container justify={"center"}>
        <h1>Potwierdzenie aktywacji konta</h1>
      </Grid>
      <Grid container justify={"center"}>
        {!success ? (
          <Alert variant="outlined" severity="success">
            Twoje konto zostało aktywowane
          </Alert>
        ) : (
          <Alert variant="outlined" severity="error">
            Coś poszło nie tak
          </Alert>
        )}
      </Grid>
    </Box>
  );
};

export default ActiveAccount;
